export default __webpack_public_path__ + "static/media/B-icon.26a026be.svg";